export const fadeInUp = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
};

export const fadeInUpLarge = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

export const scaleIn = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
};

export const transition = { duration: 0.4 };
export const transitionDelayed = { duration: 0.4, delay: 0.1 };
export const transitionMedium = { duration: 0.5 };
export const transitionSlow = { duration: 0.6, delay: 0.1 };

// Leaderboard / podium stagger animations
export const fadeIn = { initial: { opacity: 0 }, animate: { opacity: 1 } };
export const transitionPodium = { duration: 0.5, delay: 0.2 };
export const transitionTable = { duration: 0.5, delay: 0.5 };
export const podiumEntrance = (i) => ({ duration: 0.5, delay: 0.3 + i * 0.12 });
export const tableRowEntrance = (i) => ({ duration: 0.2, delay: 0.02 * i });
